var exports = {
  "nW": "readOnlyLabel__bWHv73",
  "Ug": "readOnlyIcon__3Yxoxp",
  "A$": "workflowButton__dTtq0m",
  "o0": "graphContainer__HtRYjY",
  "s8": "graphHeader__TsIzxS",
  "fc": "actionButtonsContainer__Rbnz_c",
  "SC": "mainContentArea__F_eABQ",
};

module.exports = exports;
